import {Box, Stack, Typography} from "@mui/material";
import {c, maxW} from "../landingTokens";

const COLUMNS = [
  {
    title: "Product",
    links: [
      {label: "How it works", href: "#how"},
      {label: "Capabilities", href: "#capabilities"},
      {label: "Integrations", href: "#integrations"},
      {label: "Specs", href: "#specs"},
    ],
  },
  {
    title: "Contact",
    links: [
      {label: "+389 75 753 932", href: "tel:+38975753932"},
      {label: "contact@ireason.mk", href: "mailto:contact@ireason.mk"},
      {label: "3rd Macedonian Brigade 37, Skopje"},
    ],
  },
  {
    title: "Community",
    links: [
      {label: "LinkedIn", href: "https://www.linkedin.com/company/ireason/", external: true},
      {label: "Facebook", href: "https://www.facebook.com/ireasonmk", external: true},
    ],
  },
];

const linkSx = {fontSize: "13.5px", color: c.inkSoft, textDecoration: "none", lineHeight: 1.5, "&:hover": {color: c.purpleDeep}};

export const LandingFooter = () => (
  <Box component="footer" data-screen-label="Footer" sx={{borderTop: `1px solid rgba(44,43,42,0.1)`, bgcolor: c.bgSoft}}>
    <Box
      sx={{
        maxWidth: maxW,
        mx: "auto",
        px: 2.75,
        pt: 7.75,
        pb: 5,
        display: "grid",
        gridTemplateColumns: {xs: "1fr 1fr", md: "1.5fr 1fr 1fr 1fr"},
        gap: "40px 32px",
      }}
    >
      <Box>
        <Typography sx={{fontSize: 17, fontWeight: 600, letterSpacing: "-0.015em", mb: 1}}>OpenBrain</Typography>
        <Typography sx={{fontSize: 14, color: c.inkSoft, maxWidth: 240, lineHeight: 1.5}}>
          The smarter way to handle calls.
        </Typography>
      </Box>

      {COLUMNS.map((col) => (
        <Stack key={col.title} gap={1.25}>
          <Typography sx={{fontSize: 12, fontWeight: 600, color: c.ink, mb: 0.5}}>{col.title}</Typography>
          {col.links.map((link) =>
            link.href ? (
              <Typography
                key={link.label}
                component="a"
                href={link.href}
                target={link.external ? "_blank" : undefined}
                rel={link.external ? "noreferrer" : undefined}
                sx={linkSx}
              >
                {link.label}
              </Typography>
            ) : (
              <Typography key={link.label} sx={{...linkSx, "&:hover": {}}}>{link.label}</Typography>
            )
          )}
        </Stack>
      ))}
    </Box>

    <Box sx={{maxWidth: maxW, mx: "auto", px: 2.75, pb: 5}}>
      <Stack
        direction="row"
        justifyContent="space-between"
        flexWrap="wrap"
        useFlexGap
        gap={2.5}
        sx={{borderTop: `1px solid rgba(44,43,42,0.1)`, pt: 2.75}}
      >
        <Typography sx={{fontSize: "11.5px", color: c.inkMuted}}>
          © {new Date().getFullYear()} OpenBrain by iReason. All rights reserved.
        </Typography>
        <Stack direction="row" gap={2.5}>
          {["Privacy", "Terms", "GDPR"].map((label) => (
            <Typography key={label} component="a" href="#contact" sx={{fontSize: "11.5px", color: c.inkMuted, textDecoration: "none", "&:hover": {color: c.purpleDeep}}}>
              {label}
            </Typography>
          ))}
        </Stack>
      </Stack>
    </Box>
  </Box>
);
